export default __webpack_public_path__ + "static/media/TT.9db60086.svg";